import axiosPrivate from "../../../api/axiosPrivate";
import { GET_PENDING_CLAIM_ACTIONS } from "../../../api/constant";

// Fetch all users
const getPendingClaims = async (user_role_array) => {
  const response = await axiosPrivate.post(
    `${GET_PENDING_CLAIM_ACTIONS}`,
    user_role_array
  );
  return response.data;
};

const pendingActionsService = {
  getPendingClaims,
};

export default pendingActionsService;
